import ReactGA from 'react-ga4';

// Replace with your actual GA4 Measurement ID
const GA_MEASUREMENT_ID = 'G-XXXXXXXXXX'; // You'll get this from GA4 setup

// Initialize Google Analytics
export const initGA = () => {
  ReactGA.initialize(GA_MEASUREMENT_ID, {
    debug: process.env.NODE_ENV === 'development',
    testMode: process.env.NODE_ENV === 'test',
  });
};

// Track page views
export const trackPageView = (path) => {
  ReactGA.send({ 
    hitType: 'pageview', 
    page: path 
  });
};

// Track custom events
export const trackEvent = (action, category = 'General', label = '', value) => {
  const eventData = {
    action,
    category,
    label,
  };
  
  // Only add value if it's a valid number
  if (typeof value === 'number' && value > 0) {
    eventData.value = value;
  }
  
  ReactGA.event(eventData);
};

// Specific tracking functions for your portfolio
export const trackButtonClick = (buttonName, url = '') => {
  trackEvent('click', 'Button', buttonName);
  console.log(`📊 Tracked: ${buttonName} button click`);
};

export const trackExternalLink = (linkName, url) => {
  trackEvent('click', 'External Link', linkName);
  console.log(`📊 Tracked: External link to ${linkName}`);
};

export const trackDownload = (fileName) => {
  trackEvent('download', 'File', fileName);
  console.log(`📊 Tracked: Download of ${fileName}`);
};

export const trackBlogClick = (blogTitle) => {
  trackEvent('click', 'Blog', blogTitle);
  console.log(`📊 Tracked: Blog click - ${blogTitle}`);
};

export const trackContactAction = (action) => {
  trackEvent('engagement', 'Contact', action);
  console.log(`📊 Tracked: Contact action - ${action}`);
};